import styled from "styled-components";

const Column = styled.div.withConfig({
  displayName: "Column",
})`
  display: flex;
  flex-direction: column;
`;

export default Column;
